module.exports = __webpack_public_path__ + "img/teamImg25.abba557c.jpg";